import { animateElement, getElem } from "../utils";
import { loader } from "../utils/assetLoader";
import { config } from "../utils/settings";

class HTML_UI {
    private Lives: Lives;
    private Score: Score;
    private Timer: Timer;
    private html = {
        countdown: {
            elem: getElem('countdown-container'),
            n1: getElem('countdown-1'),
            n2: getElem('countdown-2'),
            n3: getElem('countdown-3'),
            go: getElem('countdown-go'),
        },
        livesUI: getElem("game-ui-livesUI"),
        scoreUI: getElem("game-ui-scoreUI"),
        logo: getElem("game-ui-logo"),
    };

    constructor() {
        this.Lives = new Lives();
        this.Score = new Score();
        this.Timer = new Timer();
    }
    
    startCountdown(onEnd: () => {}) {
        let count = 3;
        this.html.countdown.elem.style.display = 'flex';
        this.html.countdown.n3.style.display = 'block';
        this.html.countdown.go.style.display = "none";
        
        this.showUI();
        loader.Sound("countdown-ping").play({volume: 0.4});
        const interval = setInterval(() => {
            count--;
            if (count > 0) {
                loader.Sound("countdown-ping").play({volume: 0.4});
                switch(count) {
                    case(2):
                    this.html.countdown.n3.style.display = 'none';
                    this.html.countdown.n2.style.display = 'block';
                    break;
                    case(1):
                    this.html.countdown.n2.style.display = 'none';
                    this.html.countdown.n1.style.display = 'block';
                    break;
                }
            } else if (count === 0) {
                loader.Sound("countdown-end").play({volume: 0.4});
                this.html.countdown.n1.style.display = "none";
                this.html.countdown.go.style.display = "block";
            } else {
                clearInterval(interval);
                this.html.countdown.elem.style.display = 'none';
                this.Timer.start();
                onEnd();
            }
        }, 1000);
    }

    public showUI() {
        this.html.scoreUI.style.right = '0px';
        this.html.livesUI.style.left = '0px';
        this.html.logo.style.top = '17%';
        this.reset();
    }

    public addScore(score: number) {
        this.Score.update(score);
    }

    public loseLife() {
        this.Lives.update(this.Lives.getLives() - 1);
        return (this.Lives.getLives() === 0); // Checks if should die
    }

    public getStats() {
        return {
            lives: this.Lives.getLives(),
            score: this.Score.getScore(),
            time: this.Timer.getTimeString(),
        }
    }

    public pause() {
        this.Timer.pause();
    }

    public dismiss() {
        this.html.scoreUI.style.right = '';
        this.html.livesUI.style.left = '';
        this.html.logo.style.top = '';
    }

    public reset() {
        this.Lives.reset();
        this.Score.reset();
        this.Timer.reset();
    }
}

export default HTML_UI;

class Lives {
    private html = {
        textElem: getElem("game-ui-lives"),
        text: getElem("game-ui-livesText"),
    }
    
    private defaultLives: number = config.playerLives;
    private lives: number = this.defaultLives;

    public update(lives: number) {
        this.lives = lives;
        this.displayLives();
    }

    public reset() {
        this.lives = this.defaultLives;
        this.displayLives();
    }

    // ----------------------------------------------
    // ------------------ [ Set Lives Display ] -----
    public getLives() {
        return this.lives;
    }

    private displayLives() {
        this.html.text.innerHTML = this.lives.toString();
        animateElement(this.html.textElem, true);
    }
}
class Score {
    private html = {
        textElem: getElem("game-ui-scores"),
        text: getElem("game-ui-scoreText"),
    }

    private score: number = 0;
    // ----------------------------------------------
    // ------------------ [ Exposed Functions ] -----
    public update(score: number) {
        this.score += score;
        this.displayScore();
    }

    public reset() {
        this.score = 0;
        this.displayScore();
    }

    // ----------------------------------------------
    // ------------------ [ Set Score Display ] -----
    public getScore() {
        return this.score;
    }

    private displayScore() {
        this.html.text.innerHTML = this.score.toString();
        animateElement(this.html.textElem, true);
    }
}

class Timer {
    private html = {
        text: getElem("game-ui-timeText"),
    }

    private time = {
        cur: 0,
        start: 0,
        prePause: 0,
    };
    private active = false;
    private tickerId: number | null = null;
    
    // ----------------------------------------------
    // ------------------ [ Exposed Functions ] -----
    public start() {
        if (this.active) return;
        this.active = true;
        this.time.start = Date.now();
        this.tickerId = window.setInterval(() => this.tick(), 100); // Create ticker
    }
    
    public pause() {
        if (!this.active) return;
        if (this.tickerId !== null) { // Clear ticker
            clearInterval(this.tickerId);
            this.tickerId = null;
        }
        
        // Calculate elapsed time up to now
        this.time.prePause += (Date.now() - this.time.start) / 1000;
        this.active = false;
    }

    public reset() {
        this.active = false;
        this.displayTime();

        if (this.tickerId !== null) { // Clear ticker
            clearInterval(this.tickerId);
            this.tickerId = null;
        }
        
        this.time = {
            cur: 0,
            start: 0,
            prePause: 0,
        };
    }
    
    // ----------------------------------------------
    // ----------------------------- [ Ticker ] -----
    private tick() {
        if (!this.active) return;
        this.time.cur = this.time.prePause + (Date.now() - this.time.start) / 1000;
        this.displayTime();
    }
    
    // ----------------------------------------------
    // --------------------- [ Time as String ] -----
    public getTimeString(){
        const minutes: number = Math.floor(this.time.cur / 60);
        const remainingSeconds: number = Math.floor(this.time.cur % 60);
        const timeString = `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
        return timeString;
    }

    private lastTime: number = -1;
    private convertTime(): string|null  {
        const floor = Math.floor(this.time.cur);
        if(floor === this.lastTime) {
            this.lastTime = floor;
            return null;
        } else this.lastTime = floor;
        return this.getTimeString();
    }
    
    private displayTime() {
        const timeString = this.convertTime();
        if(!timeString) return;
        this.html.text.innerHTML = timeString;

    }
}